module.exports = __webpack_public_path__ + "img/icon_intrest_redpacket_bg.db55918a.png";